import React, { useState, useEffect, useRef } from "react";
import { Bell } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import {
  showsidebar,
  hidesidebar,
} from "../../feature/sidebartoggle/sidebarToggleSlice";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import { logout } from "../../feature/user/userSlice";

import TopBarTitle from "../dashboard/TopBarTitle";
import DashBoardFilter from "../../inspired-integrated-dashboard/components/common/DashBoardFilter";
import { selectFilterOptions } from "../../feature/dashboardFilter/receivingDashboardFilterSlice";
import { formatDate } from "../../utils/formatDateTime";
import { API_Link, ValidateHeader } from "../../common/Constants";

import axios from "axios";

const Topbar = () => {
  const sidebarToggle = useSelector((state) => state.toggler.value);
  const user = useSelector((state) => state.user.user);
  const menu = user?.menu;
  const filterOptions = useSelector(selectFilterOptions);
  const sideMenu = menu?.filter((m) => m.module === "sideBar");
  const [pageTitle, setPageTitle] = useState("");
  const [notificationCount, setNotificationCount] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = user?.token;

  // Use ref to prevent multiple intervals
  const intervalRef = useRef(null);

  // Function to fetch notification count from API
  // const fetchNotificationCount = async () => {
  //   // Only fetch if token exists
  //   if (!token) return;

  //   const config = {
  //     method: "get",
  //     url: `${API_Link}finalDelayedResults`,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //       "plims-auth": ValidateHeader,
  //       Authorization: `Bearer ${token}`,
  //     },
  //   };

  //   try {
  //     const response = await axios(config);

  //     if (response.data.status === 1) {
  //       const count = response?.data.summary?.total_delayed_samples || 0;
  //       setNotificationCount(count);
  //     } else {
  //       setNotificationCount(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching notification count:", error);
  //     if (
  //       error.response &&
  //       error.response.data.message === "Unauthenticated."
  //     ) {
  //       navigate("/");
  //       sessionStorage.clear();
  //       localStorage.clear();
  //     }
  //   }
  // };

  // Initial fetch on component mount
  // useEffect(() => {
  //   if (token) {
  //     fetchNotificationCount();
  //   }
  // }, [token]);

  // Set up interval to fetch notification count every 5 seconds
  // useEffect(() => {
  //   if (!token) return;

  //   // Clear any existing interval
  //   if (intervalRef.current) {
  //     clearInterval(intervalRef.current);
  //   }

  //   // Start new interval with 5 seconds
  //   intervalRef.current = setInterval(() => {
  //     fetchNotificationCount();
  //   }, 100000); // 5 seconds = 5000 milliseconds

  //   // Cleanup interval on component unmount
  //   return () => {
  //     if (intervalRef.current) {
  //       clearInterval(intervalRef.current);
  //       intervalRef.current = null;
  //     }
  //   };
  // }, [token]); // Re-run if token changes

  const handleShowSidebar = () => {
    dispatch(showsidebar());
  };

  const handleHideSidebar = () => {
    dispatch(hidesidebar());
  };

  const params = useParams();
  const id = params.id;

  const handleLogout = () => {
    dispatch(logout(user.token))
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setPageTitle("Dashboard");
    } else if (location.pathname === "/searching") {
      setPageTitle("Searching");
    } else if (location.pathname === "/newSampleCollection") {
      setPageTitle("New Sample Collection");
    } else if (location.pathname === "/admin/users") {
      setPageTitle("Users");
    } else if (location.pathname === "/admin/addNewUser") {
      setPageTitle("Add New User");
    } else if (location.pathname === `/admin/edituser/${id}`) {
      setPageTitle("Edit User");
    } else if (location.pathname === "/admin/roles") {
      setPageTitle("Roles");
    } else if (location.pathname === "/admin/addNewRole") {
      setPageTitle("Add New Role");
    } else if (location.pathname === "/admin/editrole/:id") {
      setPageTitle("Edit Role");
    } else {
      setPageTitle("");
    }
  }, [location.pathname]);

  const [isActive, setIsActive] = useState(false);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const handlePreviewClick = (filterOptions) => {
    setIsActive(false);
  };

  return (
    <div className="top-bar">
      <div className="d-flex justify-content-between align-items-center">
        <div className="ps-2 d-flex align-items-center">
          <TopBarTitle
            pageTitleWord=""
            pageTitle="Polio Lab Information Management System"
          />
        </div>

        {(location?.pathname === "/dashboard" ||
          location?.pathname === "/recevingDashboard" ||
          location?.pathname === "/afpProcessingDashboard" ||
          location?.pathname === "/afpInaculationDashboard" ||
          location?.pathname === "/afpProcInocDashboard" ||
          location?.pathname === "/afpObservationDashboard") &&
          filterOptions && (
            <div className="d-flex align-items-center border rounded-pill-new ms-2 p-1 bg-transparent">
              <div className="text-white small">
                {filterOptions?.receving_date_from ===
                filterOptions?.receving_date_to ? (
                  formatDate(filterOptions?.receving_date_from)
                ) : (
                  <>
                    <span className="me-1">
                      {filterOptions?.receving_date_from
                        ? formatDate(filterOptions?.receving_date_from)
                        : ""}
                    </span>
                    <span className="me-1">to</span>
                    {filterOptions?.receving_date_to
                      ? formatDate(filterOptions?.receving_date_to)
                      : ""}
                  </>
                )}
              </div>
            </div>
          )}

        <div className="d-flex align-items-center gap-3 me-3">
          {/* Notification Bell with Count Badge */}
          {/* <Link to="/tatComplianceReport" className="position-relative">
            <Bell color="white" size={23} />
            {notificationCount > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{
                  fontSize: "10px",
                  padding: "4px 4px",
                  marginTop: "-5px",
                  marginLeft: "0px",
                }}
              >
                {notificationCount}
                
              </span>
            )}
          </Link> */}
          {(location?.pathname === "/dashboard" ||
            location?.pathname === "/recevingDashboard" ||
            location?.pathname === "/afpProcessingDashboard" ||
            location?.pathname === "/afpInaculationDashboard" ||
            location?.pathname === "/afpProcInocDashboard" ||
            location?.pathname === "/afpObservationDashboard") && (
            <span>
              <span className="filter-icon-2" onClick={toggleClass}>
                <i className="bi bi-sliders"></i>
              </span>
              <DashBoardFilter
                isActive={isActive}
                handlePreviewClick={handlePreviewClick}
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
